import { API_URL_BASE, htmlElem } from '../utils/globals';
import { fetchPage } from './fetchPage';
import { appendNavigationData } from './appendNavigationData';
import { addToSessionStorage, retrieveFromSessionStorage} from '../utils/utilsStorage';
import { compare } from '../utils/compare';
import { removeChildNodes } from '../utils/removeChildNodes';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';

const wrapper = document.querySelector('.main-nav');

const fetchNavigation = (tagId) => {
    const publicPagesData = retrieveFromSessionStorage('publicPages');
    removeChildNodes(wrapper);
    if (publicPagesData !== null) {
        setAjaxLoading(htmlElem);
        [...publicPagesData].forEach(item => {
            appendNavigationData(item, wrapper);
        });
        setAjaxComplete(htmlElem);
        fetchPage();
    } else {
        fetch(`${API_URL_BASE}/pages?tags=${tagId}`)
            .then((response) => response.json())
            .then((data) => {
                setAjaxLoading(htmlElem);
                const sortedData = data.sort(function(a, b) {
                    return compare(b.menu_order, a.menu_order) || compare(b.date, a.date)
                });
                sortedData.forEach(item => appendNavigationData(item, wrapper));
                addToSessionStorage('publicPages', sortedData);
            })
            .catch(err => {
                console.log(err);
                setAjaxComplete(htmlElem);
            })
            .finally(() => {
                setAjaxComplete(htmlElem);
                fetchPage();
            });
    }
}

export {
    fetchNavigation
}